export default __webpack_public_path__ + "static/media/Auto.6a168309.png";